import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DirectorioModal from "../../components/Directorio/DirectorioModal";

export default function DirectorioPage() {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Directorio General - ITE";
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    navigate("/");
  };

  return <DirectorioModal isOpen={isOpen} onClose={handleClose} />;
}
